import { defineComponent } from 'vue';
import CustomImage from '../../common/custom-image.vue';
export default defineComponent({
    components: { CustomImage: CustomImage },
    props: {
        title: {
            type: String,
            required: true,
            default: ''
        }
    }
});
